import { render } from "./BaseAuth.vue?vue&type=template&id=206f5006"
import script from "./BaseAuth.vue?vue&type=script&lang=js"
export * from "./BaseAuth.vue?vue&type=script&lang=js"

import "./BaseAuth.vue?vue&type=style&index=0&id=206f5006&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__